import { render } from "./BulletinItem.vue?vue&type=template&id=42b24974&scoped=true"
import script from "./BulletinItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./BulletinItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./BulletinItem.vue?vue&type=style&index=0&id=42b24974&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b24974"]])

export default __exports__